import { render, staticRenderFns } from "./ReportTab.vue?vue&type=template&id=2765e7be&scoped=true&"
import script from "./ReportTab.vue?vue&type=script&lang=ts&"
export * from "./ReportTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2765e7be",
  null
  
)

export default component.exports